// extracted by css-extract-rspack-plugin
export default {"mainLayout":"src-shared-components-MainLayout-MainLayout-module__mainLayout-_Ctd_b","detached":"src-shared-components-MainLayout-MainLayout-module__detached-j37jhp","topDockLayer":"src-shared-components-MainLayout-MainLayout-module__topDockLayer-CXNW2J","contentArea":"src-shared-components-MainLayout-MainLayout-module__contentArea-HgFx18"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"mainLayout\":\"src-shared-components-MainLayout-MainLayout-module__mainLayout-_Ctd_b\",\"detached\":\"src-shared-components-MainLayout-MainLayout-module__detached-j37jhp\",\"topDockLayer\":\"src-shared-components-MainLayout-MainLayout-module__topDockLayer-CXNW2J\",\"contentArea\":\"src-shared-components-MainLayout-MainLayout-module__contentArea-HgFx18\"}";
        // 1793873546069
        var cssReload = require("../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  